module.exports.getEmployees = function(siteID) {
    let employees = `select * from teamio.employees where SiteID='${siteID}';`;
    return employees;
}